var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"sidebar"},_vm._l((_vm.products),function(product){return _c('ProductInfo',{key:product.name,attrs:{"product":product}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }